import { PropsWithChildren, createContext, useContext } from 'react';

import { usePurchaseList } from './purchase-list.hook.ts';

type PurchaseListContextType = ReturnType<typeof usePurchaseList>;

export const PurchaseListContext =
    createContext<PurchaseListContextType | null>(null);

export const PurchaseListProvider = ({ children }: PropsWithChildren) => {
    const purchaseList = usePurchaseList();

    return (
        <PurchaseListContext.Provider value={purchaseList}>
            {children}
        </PurchaseListContext.Provider>
    );
};

export const usePurchaseListContext = () => {
    const context = useContext(PurchaseListContext);
    if (!context) {
        throw new Error(
            'usePurchaseListContext must be used within a PurchaseListProvider',
        );
    }
    return context;
};
